import React from 'react';
import ModalDom from '../../../../components/Modal';
import { Form, Button, Input, message } from 'antd';
import DetailTitle from '../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { postFrom, config } from '../../../../axios';
import { projectTransfer, dicPayChannel, dicPayType, dicTradeRecordStatus } from '../../../../axios/dictionaries';
import moment from 'moment'
import ActionRecords from '../../../ActionRecords/index';
import { moneyAddComma } from '../../../../utils/index';
import FileUpload from "../../../../components/FileUpload";

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            title: '',
            loading: false,
            actionVisible: false,
            referenceNumber: null, // 表单中的交易参考号
            data: {}
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    // 暴露给
    openReceived = (id, cb) => {
        this.loadPackage(id)
        this.setState({ title: '确认到账' })
        this.onReceivedCallback = cb
        
    }

    //暴露给父级的详情接口
    loadPackage = (id) => { 
        this.setState({ loading: true, title: '转账详情 【流水】' });
        let data = { tradeRecordOfflineId: id };
        postFrom({
            url: config.API_traderecordoffline_getById,
            data,
        }).then((res) => {
            res = res || {};
            if (!Array.isArray(res.bill)) {
                res.bill = [].concat(res.tradeRecordPaylog || [], res.tradeRecordOffline || []);
            }
            this.setState({ data: res, referenceNumber: res.referenceNumber, loading: false });

            if(res.attachList){
                this.fileUploadRef.setFileToState(res.attachList)
            }

        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
        })
    }

    handleReceived = () => {
        if (!this.state.referenceNumber) return message.warning('请输入交易参考号')
        this.onReceivedCallback(this.state.referenceNumber)
    }

    render() {
        let { visible, handleCancel } = this.props;
        let {
            loading,
            data,
            actionVisible

        } = this.state;


        let dicPayChannels, dicPayTypes, dicTradeRecordStatuss;
        dicPayChannels = dicPayChannel.find(item1 => data.payChannel === item1.value)
        dicPayTypes = dicPayType.find(item1 => data.payType === item1.value)
        dicTradeRecordStatuss = dicTradeRecordStatus.find(item1 => data.status === item1.value)

        return <ModalDom
            title={this.state.title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={handleCancel}
            footer={
                <div>
                    {this.state.title === '确认到账' && (
                        <Button onClick={this.handleReceived} type="primary">确认到账</Button>
                    )}
                    <Button onClick={handleCancel}>关闭</Button>
                </div>
            }
            actionRecords
            handleAction={() => {
                this.setState({ actionVisible: true });
                this.onAction.queryActionRecords({ rowId: data.id, tableName: "trade_record_offline" });
            }}
               >
            <ActionRecords
                onRef={ref => this.onAction = ref}
                visible={actionVisible}
                handleCancel={() => { this.setState({ actionVisible: false }) }}
            />
            <div className="custom">
                <DetailTitle title="租客" boxStyle={{ marginTop: 0 }} />
                <CustomRow>
                    <CustomCol label="姓名" required={false} >
                        <Input
                            disabled
                            value={data.customerName}
                        />
                    </CustomCol>
                    <CustomCol label="证件号码" required={false} >
                        <Input
                            disabled
                            value={data.credentialNumber}
                        />
                    </CustomCol>
                    <CustomCol label="手机号码" required={false} >
                        <Input
                            disabled
                            value={data.customerPhone}
                        />
                    </CustomCol>
                </CustomRow>
                <DetailTitle title="转账" />
                <CustomRow>
                    <CustomCol label="转账渠道" required={false} >
                        <Input
                            disabled
                            value={dicPayChannels ? dicPayChannels.title : ''}
                        />
                    </CustomCol>
                    <CustomCol label="转账日期" required={false} >
                        <Input
                            disabled
                            value={data.tradeTime ? moment(data.tradeTime).format('YYYY-MM-DD') : data.payDate ? moment(data.payDate).format('YYYY-MM-DD') : ''}
                        />
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol label="转账金额" required={false} subfix={<div style={{ background: "#f0f2f5" }}>元</div>} >
                        <Input
                            disabled
                            value={moneyAddComma(data.amount)}
                        />
                    </CustomCol>
                    <CustomCol label="入账渠道" required={false}  >
                        <Input
                            disabled
                            value={data.orderNo || data.searialNumber}
                        />
                    </CustomCol>
                    <CustomCol label="交易参考号"   >
                        <Input
                            disabled={this.state.title !== '确认到账'}
                            value={this.state.referenceNumber}
                            onChange={(e) => this.setState({ referenceNumber: e.target.value })}
                        />
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol label="核销人" required={false} >
                        <Input
                            disabled
                            value={data.checkEmployeeName}
                        />
                    </CustomCol>
                    <CustomCol label="核销时间" required={false}  >
                        <Input
                            disabled
                            value={data.checkTime && moment(data.checkTime).format('YYYY-MM-DD') }
                        />
                    </CustomCol>
                    <CustomCol label="审核状态" required={false}  >
                        <Input
                            disabled
                            value={data.status && projectTransfer.find(e=>e.value === data.status).title}
                        />
                    </CustomCol>
                </CustomRow>
                <DetailTitle title="账单" />
                <div className="tableBox">
                    <div className="tableTitle">
                        <div style={{ flex: 1 }}>应收日期</div>
                        <div style={{ flex: 1 }}>房源</div>
                        <div style={{ flex: 1 }}>账单名称</div>
                        <div style={{ flex: 1 }}>账单周期</div>
                        <div style={{ flex: 1 }}>应收金额（元）</div>
                        {/* <div style={{ flex: 1 }}>核销日期</div> */}
                        <div style={{ flex: 1 }}>核销金额（元）</div>
                    </div>
                    <div className="tableBody">
                        {
                            data.bill instanceof Array && data.bill.length > 0
                                ? data.bill.map((item, index) => {
                                    return (
                                        <div className="tableBodyRow" key={index}>
                                            <div style={{ flex: 1 }}>{item.mustPayDate ? moment(item.mustPayDate).format('YYYY-MM-DD') : null}</div>
                                            <div style={{ flex: 1, flexDirection: "column" }}>
                                                <div>
                                                    {item.roomNo ? item.roomNo : null}
                                                </div>
                                                <div>
                                                    {item.buildingName ? item.buildingName : null}
                                                </div>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                {item.feeName ? item.feeName : null}
                                            </div>
                                            <div style={{ flex: 1, flexDirection: "column" }}>
                                                <div>
                                                    {item.billBeginDate ? moment(item.billBeginDate).format('YYYY-MM-DD') : null}
                                                </div>
                                                <div>
                                                    {item.billEndDate ? moment(item.billEndDate).format('YYYY-MM-DD') : null}
                                                </div>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                {item.billMoney ? moneyAddComma(item.billMoney) : null}
                                            </div>
                                            {/* <div style={{ flex: 1 }}>{
                                                item.verificationTime ? moment(item.verificationTime).format('YYYY-MM-DD') : null
                                            }</div> */}
                                            <div style={{ flex: 1, color: "red" }}>{moneyAddComma(item.allocationAmount)}</div>
                                        </div>
                                    )
                                })
                                : <div className="tableBodyRow" style={{ lineHeight: '34px', justifyContent: 'center' }} >暂无数据</div>
                        }
                    </div>
                </div>
                <DetailTitle title="转账附件" />
                <FileUpload hideLabel ref={(ref) => this.fileUploadRef = ref} tableName="tradeRecordOffline"  fileTypeList={[17]} isValueStyle />

            </div>
        </ModalDom>
    }


}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Payment/components/Transfer/Detail.js